export const MuiCardMediaTheme = () => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                hasPixelTheme: "true",
                flexShrink: 0,
                "&:not(img):not(:empty)": {
                    padding: 16,
                },
            },
        },
    };
};
